import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import MediaProcessFlow from "./MediaProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";
import {
  MEDIA_DOMAIN_INTRO,
  MEDIA_GROUPS,
  MEDIA_USE_CASES_SEO,
  MEDIA_DOMAIN_FAQS,
  MEDIA_ITEM_LIST_JSONLD,
  MEDIA_BREADCRUMB_JSONLD,
  MEDIA_WEBPAGE_JSONLD,
  MEDIA_FAQ_JSONLD,
} from "../../data/mediaUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<MediaProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = MEDIA_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">{cases.map((uc) => <UseCaseCard key={uc.id} useCase={uc} />)}</div>
    </section>
  );
}

export default function MediaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups = activeFilter === "all" ? MEDIA_GROUPS : MEDIA_GROUPS.filter((g) => g.id === activeFilter);
  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={MEDIA_DOMAIN_INTRO}
        domainSlug="media-domain"
        useCaseCount={MEDIA_USE_CASES_SEO.length}
        groupCount={MEDIA_GROUPS.length}
        itemListJsonLd={MEDIA_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={MEDIA_BREADCRUMB_JSONLD}
        faqJsonLd={MEDIA_FAQ_JSONLD}
        webPageJsonLd={MEDIA_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{MEDIA_DOMAIN_INTRO.title}</h1>
          {MEDIA_DOMAIN_INTRO.content ? <p>{MEDIA_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid useCases={MEDIA_USE_CASES_SEO} groups={MEDIA_GROUPS} heading="Media & Entertainment Use Cases" onFilterChange={setActiveFilter} />
      <div className="fin-wrap">{visibleGroups.map((group) => <GroupSection key={group.id} group={group} />)}</div>
      <DomainHiddenSeoContent
        domainTitle={MEDIA_DOMAIN_INTRO.title}
        domainFaqs={MEDIA_DOMAIN_FAQS}
        useCases={MEDIA_USE_CASES_SEO}
      />
    </div>
  );
}

